import { createGlobalStyle } from "styled-components";
import backgroundImage from "./PhotosGallery/roads.jpg"; // Update the path as needed

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    color: darkgoldenrod;
    background: url(${backgroundImage}) no-repeat center center fixed;
    background-size: cover;
  }

  h1, h2, h3 {
    margin: 0.5em 0;
    text-align: center;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 1.5rem;
    }
  }

  @media (max-width: 480px) {
    h1 {
      font-size: 1.2rem;
    }
  }
`;

export default GlobalStyle;
